<div class="container-fluid finance-wrapper mt-1">

  <div class="row g-4">

    <!-- ================= LONG TERM LOAN ================= -->
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 d-flex" >
      <div class="finance-card mb-3">
        <div class="finance-header"><i class="fas fa-building-columns"></i> Long Term Loan </div>

        <div class="finance-info">
          <p><strong>Loan Eligible:</strong> ₹{{ FID.LT_allow | number:'1.0-2' }}</p>
          <p><strong>Loan Availed:</strong> ₹{{ FID.LT_balance | number:'1.0-2' }}</p>
        </div>

        <hr />

        <div class="form-group">
          <label for="loanRequest">Long Term Loan Request (₹)</label>
          <input type="number" [(ngModel)]="FID.LT_borrow" (input)="CTW_LT_borrow()" class="form-control"
            placeholder="Enter loan amount" id="loanRequest" name="loanRequest"/>
          <small>{{ LT_borrowInWords }}</small>
        </div>

        <div class="form-group">
          <label for="loanRepay">Long Term Loan Repay (₹)</label>
          <input type="number" [(ngModel)]="FID.LT_repay" (input)="CTW_LT_repay()" placeholder="Enter Term Loan Repay" class="form-control" id="loanRepay" name="loanRepay" />
          <small>{{ LT_borrowInWords }}</small>
        </div>

      </div>
    </div>

    <!--================= SHORT TERM LOAN =================-->
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 d-flex">
      <div class="finance-card mb-3">
        <div class="finance-header"><i class="fas fa-coins"></i> Short Term Loan</div>

        <div class="finance-info">
          <p><strong>Loan Eligible:</strong> ₹{{ FID.ST_allow | number:'1.0-2' }}</p>
          <p><strong>Loan Availed:</strong> ₹{{ FID.ST_balance | number:'1.0-2' }}</p>
        </div>

        <p class="text-muted notedown">
          Short term loan already availed gets automatically repayed on first day of next year.
        </p>

        <hr />

        <div class="form-group">
          <label for="loanReq">Loan Request (₹)</label>
          <input type="number" [(ngModel)]="FID.ST_borrow" id="loanReq" name="loanReq" placeholder="Enter Loan Request" (input)="CTW_ST_borrow()" class="form-control" />
          <small>{{ ST_borrowInWords }}</small>
        </div>

      </div>
    </div>
  </div>  

  <div class="row g-4">
    <!--================= SHARE DECISIONS =================-->
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 d-flex">
      <div class="finance-card mb-1">
        <div class="finance-header"><i class="fas fa-chart-line"></i> Share Holder Decisions</div>

        <div class="finance-info">
          <p><strong>Issued Shares:</strong> {{ FID.Noofshares | number }}</p>
          <p><strong>Share Price:</strong> ₹{{ FID.sharevalue | number:'1.0-2' }}</p>
        </div>

        <p class="text-muted notedown">
          You can issue or buyback only 10% shares.
        </p>

        <hr />

        <div class="form-group">
          <label for="issueShare">Issue Shares</label>
          <input type="number" [(ngModel)]="FID.I_share" (input)="CTW_I_share()" class="form-control" placeholder="Enter Issue Shares" id="issueShare" name="issueShare"/>
          <small>{{ I_shareInWords }}</small>
        </div>

        <div class="form-group">
          <label for="buybackShare">Buyback Shares</label>
          <input type="number" [(ngModel)]="FID.Bb_share" (input)="CTW_Bb_share()" class="form-control" placeholder="Enter Buyback Shares" id="buybackShare" name="buybackShare"/>
          <small>{{ Bb_shareInWords }}</small>
        </div>

        <div class="form-group">
          <label for="dividentperShare">Dividend Per Share</label>
          <input type="number" [(ngModel)]="FID.Dividend" (input)="CTW_Dividend()" class="form-control" placeholder="Enter Dividend Per Share" id="dividentperShare" name="dividentperShare"/>
          <small>{{ DividendInWords }}</small>
        </div>

      </div>
    </div>

    <!--================= DEBTORS & CREDITORS =================-->
    <div class="col-lg-6 col-md-6 col-sm-6 col-12 d-flex">
      <div class="finance-card mb-1">

        <div class="finance-header"><i class="fas fa-file-invoice-dollar"></i> Debtors & Creditors</div>

        <div class="form-group">
          <label for="accountPayable">Accounts Payable</label>
          <select class="form-select" [(ngModel)]="selectedAP" (change)="onAPChange()" id="accountPayable" name="accountPayable">
            <option [ngValue]="null" disabled>Select no of {{ RO.RoundSubUnit }}</option>
            <option *ngFor="let val of APselectvals" [ngValue]="val">{{ val }}</option>
          </select>
        </div>

        <div class="form-group">
          <label for="accReceivable">Accounts Receivable</label>
          <select class="form-select" [(ngModel)]="selectedAR" (change)="onARChange()" id="accReceivable" name="accReceivable">
            <option [ngValue]="null" disabled>Select no of {{ RO.RoundSubUnit }}</option>
            <option *ngFor="let val of ARselectvals" [ngValue]="val">{{ val }}</option>
          </select>
        </div>

      </div>
    </div>

  </div>

</div>